import { useEffect, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import { Card, Checkbox, Modal, Skeleton } from "antd";

// --------------------- Import Styles ---------------------
import { ContainerModal, ItemWrapper, Title } from "../styles";

// --------------------- Import Hooks ---------------------
import { useBuscarCaracteristicas } from "../hooks/useBuscarCaracteristicas";
import { useCadastrarCaracteristicasEmpreendimento } from "../hooks/useCadastrarCaracteristicasEmpreendimento";
import { useBuscarCaracteristicasEmpreendimento } from "../hooks/useBuscarCaracteristicasEmpreendimento";

// --------------------- Import Uteis ---------------------
import { useMessage } from "../../../uteis/mensagens/useMessage";

// --------------------- Import Interfaces ---------------------
import { Caracteristicas } from "../../../interfaces/Caracteristicas";
import { ModalEmpreendProps } from "../interfaces/ModalEmpreendProps";
import {
  CadastrarCaracteristicasDTO,
  CaracteristicasEmprendimento,
} from "../../../interfaces/CaracteristicasEmprendimento";

export default function ModalCaracteristicas({
  isModalOpen,
  handleFechar,
  empreendId,
  buscar,
}: ModalEmpreendProps) {
  const [caracteristicasEmp, setCaracteristicasEmp] =
    useState<CadastrarCaracteristicasDTO>({
      empreendId,
      caracteristicaId: [],
    });

  const [caracteristicasEmpOrigin, setCaracteristicasEmpOrigin] = useState<
    CaracteristicasEmprendimento[]
  >([]);

  const [selecionados, setSelecionados] = useState<number[]>([]);

  const handleChange = (values: number[]) => {
    setSelecionados(values);
    setCaracteristicasEmp({
      empreendId,
      caracteristicaId: values,
    });
  };

  const { caracteristicas, isLoading } = useBuscarCaracteristicas();

  const {
    caracteristicasEmpreend,
    isLoading: isLoadingCaracteristicasEmprend,
  } = useBuscarCaracteristicasEmpreendimento(isModalOpen, empreendId);

  const {
    cadastrar,
    isLoading: isLoadingCadastrar,
    error,
    success,
    resetSuccess,
    resetError,
  } = useCadastrarCaracteristicasEmpreendimento();

  // Exibe a Mensagem de  Erro
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        setSuccessDisplayed(false);
        resetSuccess();
        handleFechar();
        buscar?.();
      }, 2000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
    handleFechar,
    buscar,
  ]);

  useEffect(() => {
    const ids = caracteristicasEmpreend?.map((c) => c.caracteristicaId) ?? [];
    setSelecionados(ids);
    setCaracteristicasEmpOrigin(caracteristicasEmpreend ?? []);
  }, [caracteristicasEmpreend]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText={caracteristicasEmpreend.length > 0 ? "Atualizar" : "Cadastar"}
        confirmLoading={isLoadingCadastrar}
        onOk={() => cadastrar(caracteristicasEmp, caracteristicasEmpOrigin)}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoading && isLoadingCaracteristicasEmprend && <Skeleton active />}
        {!isLoading && !isLoadingCaracteristicasEmprend && (
          <>
            {contextHolder}
            <Card
              title={<Title>Caracteristicas</Title>}
              style={{
                width: "100%",
                marginTop: "20px",
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <ContainerModal>
                <ItemWrapper>
                  <Checkbox.Group
                    options={caracteristicas?.map((item: Caracteristicas) => ({
                      label: item.nome,
                      value: item.id,
                    }))}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px",
                      alignItems: "center",
                    }}
                    onChange={handleChange}
                    value={selecionados} // controla o valor
                  />
                </ItemWrapper>
              </ContainerModal>
            </Card>
          </>
        )}
      </Modal>
    </>
  );
}
